/* eslint-disable no-restricted-exports */
export { default } from './EntitlementInsights';
